import { Reducer } from 'redux';
import {
  MeasurementCardResponse,
  StackFilterOptionsResponse,
  StackStatisticsQueryRequest,
  StackStatisticsResponse,
} from '../.generated/api';

export const UPDATE_DASHBOARD_MEASUREMENT_CARD =
  'UPDATE_DASHBOARD_MEASUREMENT_CARD';
export const UPDATE_DASHBOARD_STACK_STATISTICS =
  'UPDATE_DASHBOARD_STACK_STATISTICS';
export const UPDATE_DASHBOARD_FILTER_OPTIONS =
  'UPDATE_DASHBOARD_FILTER_OPTIONS';

export interface DashboardState {
  measurementCard?: MeasurementCardResponse | null;
  stackStatistics?: StackStatisticsResponse | null;
  filters?: StackStatisticsQueryRequest;
  filtersApplied: number;
  updatedAt?: Date; // latest statistics query timestamp
  filterOptions?: StackFilterOptionsResponse | null;
}

export interface UpdateDashboardMeasurementCard {
  type: typeof UPDATE_DASHBOARD_MEASUREMENT_CARD;
  measurementCard?: MeasurementCardResponse | null;
}

export interface UpdateDashboardStackStatistics {
  type: typeof UPDATE_DASHBOARD_STACK_STATISTICS;
  stackStatistics?: StackStatisticsResponse | null;
  filters?: StackStatisticsQueryRequest;
}

export interface UpdateDashboardFilterOptions {
  type: typeof UPDATE_DASHBOARD_FILTER_OPTIONS;
  filterOptions?: StackFilterOptionsResponse | null;
}
type DashboardActionTypes =
  | UpdateDashboardStackStatistics
  | UpdateDashboardMeasurementCard
  | UpdateDashboardFilterOptions;

const countFiltersApplied = (filters?: StackStatisticsQueryRequest) => {
  let count = 0;
  if (filters) {
    filters.sawmillIds && (count += filters.sawmillIds.length);
    filters.surveyors && (count += filters.surveyors.length);
    filters.treeSpecies && (count += filters.treeSpecies.length);
    filters.assortments && (count += filters.assortments.length);
    filters.areaNumber && count++;
    filters.assortmentLengthMin && filters.assortmentLengthMax && count++;
  }
  return count;
};

const dashboardReducer: Reducer<DashboardState, DashboardActionTypes> = (
  state: DashboardState | undefined,
  incomingAction: DashboardActionTypes,
): DashboardState => {
  if (state === undefined) {
    return {
      stackStatistics: null,
      filtersApplied: 0,
      filterOptions: null,
      measurementCard: null,
    };
  }
  switch (incomingAction.type) {
    case UPDATE_DASHBOARD_MEASUREMENT_CARD:
      return {
        ...state,
        measurementCard: incomingAction.measurementCard,
      };
    case UPDATE_DASHBOARD_STACK_STATISTICS:
      return {
        ...state,
        stackStatistics: incomingAction.stackStatistics,
        filters: incomingAction.filters,
        filtersApplied: countFiltersApplied(incomingAction.filters),
        updatedAt: new Date(),
      };
    case UPDATE_DASHBOARD_FILTER_OPTIONS: {
      return {
        ...state,
        filterOptions: incomingAction.filterOptions,
      };
    }
    default:
      return state;
  }
};

export { dashboardReducer };
